import script from "./OrderShowTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderShowTable.vue?vue&type=script&setup=true&lang=js"

import "./OrderShowTable.vue?vue&type=style&index=0&id=680fa9f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680fa9f3"]])

export default __exports__